export const newsOverviewRoute: string = "news/overview";
export const newsItemRoute: string = "news/item/:id";
export const newsItemRouteLinkPrefix: string = "/news/item/";

export const newsFeedRoute: string = "news/feed/:newsType";
export const newsFeedRouteLinkPrefix: string = "/news/feed/";
